import axios from 'axios'
import router from '@/router'
import { vuexFileBase } from '@/store/compositionV2/utils/file'
import { PVCApi, PVCClientApi } from '@/api/pvc'
import pvhApi from '@/api/pvhApi'
import usersApi from '@/api/usersApi'
import { config, url } from '@/store'
import { currentDateTime } from '@/utils/utils'
import { showAlertError } from '@/utils/store/alert'

const EOrderFiles = {
  samples: 'samples',
  treaties: 'treaties',
  other: 'other',
  photographs: 'photographs'
}

const state = () => ({
  api: PVCApi,

  ...vuexFileBase.createState(Object.values(EOrderFiles)),

  order: {
    name: '',
    is_entity: false,
    statuses: [],
    is_check: false,
    comment: '',
    oldComment: '',
    comments: [],
    updatedComments: [],
    deletedComments: [],
    value: '',
    gauger: {
      name: 'Не выбрано',
      id: null
    },
    installer: {
      name: 'Не выбрано',
      id: null
    },
    gauging_date: '',
    client: {
      id: null,
      name: '',
      surname: '',
      patronymic: '',
      email: '',
      address: '',
      phone: '',
      comment: '',
      profile: {
        full_name: ''
      },
      informer: {
        name: 'Не выбрано',
        id: null
      },
      select: {
        name: 'Не выбрано',
        id: null
      }
    },
    costTypeModal: {
      active: false,
      updatedId: null,
      value: '',
      select: {
        name: 'Не выбрано',
        id: null
      },
      validation: {
        value: {
          type: null,
          message: ''
        }
      }
    },
    costType: {
      id: null,
      value: '',
      select: {
        name: 'Не выбрано',
        id: null
      }
    },
    costTypeIsActiveDelete: false,
    costTypes: [],
    costTypeTableHeaders: {
      allActive: false,
      header: [
        {
          title: 'Тип расхода',
          isSortable: false
        },
        {
          title: 'Сумма',
          isSortable: false
        }
      ]
    },
    comingTypeModal: {
      active: false,
      updatedId: null,
      value: '',
      select: {
        name: 'Не выбрано',
        id: null
      },
      validation: {
        value: {
          type: null,
          message: ''
        }
      }
    },
    comingType: {
      id: null,
      value: '',
      select: {
        name: 'Не выбрано',
        id: null
      }
    },
    comingTypeIsActiveDelete: false,
    comingTypes: [],
    comingTypeTableHeaders: {
      allActive: false,
      header: [
        {
          title: 'Тип прихода',
          isSortable: false
        },
        {
          title: 'Сумма',
          isSortable: false
        }
      ]
    },
    objectModal: {
      active: false,
      updatedId: null,
      name: '',
      code: '',
      validation: {
        name: {
          type: null,
          message: ''
        },
        code: {
          type: null,
          message: ''
        }
      }
    },
    object: {
      id: null,
      name: '',
      code: ''
    },
    objectIsActiveDelete: false,
    objects: [],
    objectTableHeaders: {
      allActive: false,
      header: [
        {
          title: 'Наименование',
          isSortable: false
        },
        {
          title: 'Шифр',
          isSortable: false
        }
      ]
    },
    contractor: { id: null, name: 'Не выбрано' },
    status: {
      fields: []
    },
    samples: [],
    other: [],
    treaties: [],
    photographs: []
  },

  orderTypes: [],
  deliveryMethods: [],
  contractors: [],
  gaugers: [],
  costTypes: [],
  comingTypes: [],
  installers: [],
  clients: [],
  informerTypes: [],
  access: {
    code: true,
    status: true,
    orderType: true,
    samples: true,
    availabilityDate: true,
    gaugingDate: true,
    advanceDate: true,
    installationDate: true,
    gauger: true,
    installer: true,
    agent: true,
    value: true,
    delivery: true,
    isCheck: true,
    treaties: true,
    other: true,
    photographs: true,
    costs: true,
    incomes: true,
    client: true,
    squareMetes: true,
    count: true,
    codeRal: true,
    depth: true
  },
  validation: {
    name: { type: null, message: '' },
    clientName: { type: null, message: '' },
    clientPhone: { type: null, message: '' },
    clientEmail: { type: null, message: '' },
    orderType: { type: null, message: '' },
    orderStatus: { type: null, message: '' },
    comment: { type: null, message: '' }
  },
  isLoading: true
})

const getters = {
  '[pvh] getOrderForUpdate': state => state.order,
  '[pvh] getOrderUpdateCommentValue': state => state.order.comment,
  '[pvh] getOrderUpdateOldCommentValue': state => state.order.oldComment,
  '[pvh] getOrderUpdateComments': state => state.order.comments,
  '[pvh] getOrderUpdateOrderTypes': state => state.orderTypes,
  '[pvh] getOrderUpdateContractors': state => state.contractors,
  '[pvh] getOrderUpdateDeliveryMethods': state => state.deliveryMethods,
  '[pvh] getOrderUpdateGaugers': state => state.gaugers,
  '[pvh] getOrderUpdateInstallers': state => state.installers,
  '[pvh] getOrderUpdateClients': state => state.clients,
  '[pvh] getOrderUpdateClient': state => state.order.client,
  '[pvh] getOrderUpdateInformerTypes': state => state.informerTypes,
  '[pvh] getOrderUpdateCostTypes': state => state.costTypes,
  '[pvh] getOrderUpdateCostTypesTable': state => state.order.costTypes,
  '[pvh] getOrderUpdateCostTypesTableHeaders': state => state.order.costTypeTableHeaders,
  '[pvh] getOrderUpdateCostTypeModal': state => state.order.costTypeModal,
  '[pvh] getOrderUpdateCostTypeIsActiveDelete': state => state.order.costTypeIsActiveDelete,
  '[pvh] getOrderUpdateComingTypes': state => state.comingTypes,
  '[pvh] getOrderUpdateComingTypesTable': state => state.order.comingTypes,
  '[pvh] getOrderUpdateComingTypesTableHeaders': state => state.order.comingTypeTableHeaders,
  '[pvh] getOrderUpdateComingTypeModal': state => state.order.comingTypeModal,
  '[pvh] getOrderUpdateComingTypeIsActiveDelete': state => state.order.comingTypeIsActiveDelete,
  '[pvh] getOrderUpdateObjects': state => state.objects,
  '[pvh] getOrderUpdateObjectsTable': state => state.order.objects,
  '[pvh] getOrderUpdateObjectsTableHeaders': state => state.order.objectTableHeaders,
  '[pvh] getOrderUpdateObjectModal': state => state.order.objectModal,
  '[pvh] getOrderUpdateObjectIsActiveDelete': state => state.order.objectIsActiveDelete,
  '[pvh] getOrderUpdateAccess': state => state.access,
  '[pvh] getOrderUpdateValidation': state => state.validation,
  '[pvh] getOrderUpdateIsLoading': state => state.isLoading
}

const mutations = {
  ...vuexFileBase.createMutations(),

  '[pvh] GET_ORDER': (state, order) => {
    state.order = order
  },
  '[pvh] GET_ORDER_FOR_UPDATE': (state, order) => {
    const sOrder = state.order
    const customLabel = `${order.client?.phone ?? ''} ${order.client?.surname ?? ''} ${order.client?.name ?? ''} ${order.client?.patronymic ?? ''}${order.client?.address ?? ''}`.trim()

    sOrder.id = order.id
    sOrder.code = order.code
    sOrder.square_meters = order.square_meters
    sOrder.count = order.count
    sOrder.code_ral = order.code_ral
    sOrder.depth = order.depth
    sOrder.availability_date = order.availability_date ?? ''
    sOrder.installation_date = order.installation_date ?? ''
    sOrder.gauging_date = order.gauging_date ?? ''
    sOrder.advance_date = order.advance_date ?? ''
    sOrder.value = order.value
    sOrder.client = order.client ? order.client : {}
    sOrder.client.select = {
      id: order.client ? order.client.id : null,
      name: order.client ? customLabel : 'Не выбрано'
    }
    sOrder.contractor = {
      id: order.agent ? order.agent.id : null,
      name: order.agent ? order.agent.long_name : 'Не выбрано'
    }

    sOrder.deliveryMethod = order.delivery
    sOrder.comments = order.comments ? order.comments.map(e => {
      return {
        value: e.text,
        name: e.user.profile.full_name,
        position: e.user?.position?.name,
        created_at: e.created_at,
        id: e.id,
        isControlsActive: false
      }
    }) : []
    sOrder.orderType = {
      id: order.order_type.id,
      name: order.order_type.name
    }
    sOrder.status = {
      ...order.status,
      id: order.status.id,
      name: order.status.name
    }
    sOrder.gauger = {
      id: order.gauger ? order.gauger.id : null,
      name: order.gauger ? order.gauger.profile.full_name : 'Не выбрано'
    }
    sOrder.installer = {
      id: order.installer ? order.installer.id : null,
      name: order.installer ? order.installer.profile.full_name : 'Не выбрано'
    }
    sOrder.objects = order.facilities ? order.facilities.map(e => {
      return {
        name: e.name,
        code: e.code,
        id: e.id,
        isActive: false
      }
    }) : []
    sOrder.costTypes = order.costs ? order.costs.map(e => {
      return {
        value: e.value,
        select: e.cost_type,
        id: e.id,
        isActive: false
      }
    }) : []
    sOrder.comingTypes = order.incomes ? order.incomes.map(e => {
      return {
        value: e.value,
        select: e.income_type,
        id: e.id,
        isActive: false
      }
    }) : []
    sOrder.samples = order.samples ? order.samples.map(e => {
      return {
        name: e.file_name,
        size: e.file_size,
        url: e.url,
        type: e.content_type,
        id: e.id
      }
    }) : []
    sOrder.deleteSamplesFiles = []

    sOrder.treaties = order.treaties ? order.treaties.map(e => {
      return {
        name: e.file_name,
        size: e.file_size,
        url: e.url,
        type: e.content_type,
        id: e.id
      }
    }) : []
    sOrder.deleteTreatiesFiles = []

    sOrder.other = order.other ? order.other.map(e => {
      return {
        name: e.file_name,
        size: e.file_size,
        url: e.url,
        type: e.content_type,
        id: e.id
      }
    }) : []
    sOrder.deleteOtherFiles = []

    sOrder.photographs = order.photographs ? order.photographs.map(e => {
      return {
        name: e.file_name,
        size: e.file_size,
        url: e.url,
        type: e.content_type,
        id: e.id
      }
    }) : []
    sOrder.deletePhotographsFiles = []
    state.isLoading = false
  },
  '[pvh] SET_ORDER_UPDATE_COMMENT': (state, comment) => {
    state.order.comment = comment
  },
  '[pvh] SET_ORDER_UPDATE_EDIT_COMMENT': (state, comment) => {
    state.order.comment = comment
    state.order.oldComment = comment
    state.order.comments.forEach(e => {
      e.isControlsActive = false
    })
  },
  '[pvh] DELETE_ORDER_UPDATE_COMMENT': (state, comment) => {
    const newArr = state.order.comments.filter(e => { return e.id !== comment.id })
    state.order.comments = newArr
    state.order.comments.forEach(e => {
      e.isControlsActive = false
    })
    state.order.oldComment = ''
    if (!comment.newComment) {
      state.order.deletedComments.push(comment.id)
    }
  },
  '[pvh] CLOSE_ORDER_UPDATE_CONTROLS_COMMENT': (state) => {
    state.order.comments.forEach(e => {
      e.isControlsActive = false
    })
  },
  '[pvh] TOGGLE_ORDER_UPDATE_CONTROLS_COMMENT': (state, id) => {
    state.order.comments.forEach(e => {
      e.isControlsActive = false
      if (e.id === id) {
        e.isControlsActive = true
      } else {
        e.isControlsActive = false
      }
    })
  },
  '[pvh] CREATE_ORDER_UPDATE_COMMENT': (state, user) => {
    state.order.oldComment = ''
    const comment = state.order.comment.trim()
    const comments = state.order.comments
    if (comment.length > 0) {
      let newId = 0
      comments.forEach(e => {
        if (e.id >= newId) {
          newId = e.id + 1
        }
      })

      const newComment = {
        value: comment,
        name: user.profile.full_name,
        position: user?.position?.name,
        created_at: currentDateTime(),
        isControlsActive: false,
        id: newId,
        newComment: true
      }
      comments.push(newComment)
      state.order.comment = ''
    }
  },
  '[pvh] SAVE_ORDER_UPDATE_COMMENT': (state, user) => {
    const comment = state.order.comment.trim()
    const comments = state.order.comments

    comments.forEach(elem => {
      if (elem.value === state.order.oldComment) {
        elem.value = comment

        if (!elem.newComment) {
          state.order.updatedComments.push(elem.id)
        }
        state.order.comment = ''
        state.order.oldComment = ''
      }
    })
  },
  '[pvh] GET_ORDER_UPDATE_ORDER_TYPES': (state, orderTypes) => {
    state.orderTypes = orderTypes.map(type => {
      return {
        name: type.name,
        id: type.id,
        statuses: type.statuses
      }
    })
  },
  '[pvh] GET_ORDER_UPDATE_CONTRACTORS': (state, contractors) => {
    state.contractors = contractors.map(contractor => {
      return {
        name: contractor.long_name,
        id: contractor.id
      }
    })
  },
  '[pvh] GET_ORDER_UPDATE_DELIVERY_METHODS': (state, deliveryMethods) => {
    state.deliveryMethods = deliveryMethods.map(delivMethod => {
      return {
        name: delivMethod.name,
        id: delivMethod.id
      }
    })
  },
  '[pvh] GET_ORDER_UPDATE_COST_TYPES': (state, costTypes) => {
    state.costTypes = costTypes.map(costType => {
      return {
        name: costType.name,
        id: costType.id
      }
    })
  },
  '[pvh] GET_ORDER_UPDATE_COMING_TYPES': (state, comingTypes) => {
    state.comingTypes = comingTypes.map(comingType => {
      return {
        name: comingType.name,
        id: comingType.id
      }
    })
  },
  '[pvh] GET_ORDER_UPDATE_CLIENTS': (state, clients) => {
    state.clients = [...clients]
  },
  '[pvh] GET_ORDER_UPDATE_USERS': (state, gaugers) => {
    state.gaugers = gaugers.map(gauger => {
      return {
        name: gauger.profile.full_name,
        id: gauger.id
      }
    })
    state.installers = gaugers.map(installer => {
      return {
        name: installer.profile.full_name,
        id: installer.id
      }
    })
  },

  '[pvh] SET_ORDER_UPDATE_ORDER_TYPE': (state, type) => {
    state.order.orderType = type
    state.order.status = { name: 'Не выбрано', id: null }

    if (type.statuses === null) {
      type.statuses = [
        {
          name: 'Список пуст',
          id: null
        }
      ]
    }
  },
  '[pvh] SET_ORDER_UPDATE_ACCESS': (state) => {
    if (state.order.status.name !== 'Не выбрано' && state.order.status.fields) {
      for (const key in state.access) {
        state.access[key] = false
      }
      state.order.status.fields.forEach(e => {
        if (e.field === 'code') {
          state.access.code = true
        } else if (e.field === 'status') {
          state.access.status = true
        } else if (e.field === 'order_type') {
          state.access.orderType = true
        } else if (e.field === 'samples') {
          state.access.samples = true
        } else if (e.field === 'availability_date') {
          state.access.availabilityDate = true
        } else if (e.field === 'gauging_date') {
          state.access.gaugingDate = true
        } else if (e.field === 'advance_date') {
          state.access.advanceDate = true
        } else if (e.field === 'installation_date') {
          state.access.installationDate = true
        } else if (e.field === 'gauger') {
          state.access.gauger = true
        } else if (e.field === 'installer') {
          state.access.installer = true
        } else if (e.field === 'agent') {
          state.access.agent = true
        } else if (e.field === 'value') {
          state.access.value = true
        } else if (e.field === 'delivery') {
          state.access.deliverye = true
        } else if (e.field === 'is_check') {
          state.access.isCheck = true
        } else if (e.field === 'treaties') {
          state.access.treaties = true
        } else if (e.field === 'other') {
          state.access.other = true
        } else if (e.field === 'photographs') {
          state.access.photographs = true
        } else if (e.field === 'costs') {
          state.access.costs = true
        } else if (e.field === 'photographs') {
          state.access.incomes = true
        } else if (e.field === 'client') {
          state.access.client = true
        } else if (e.field === 'square_meters') {
          state.access.squareMetes = true
        } else if (e.field === 'count') {
          state.access.count = true
        } else if (e.field === 'code_ral') {
          state.access.codeRal = true
        } else if (e.field === 'depth') {
          state.access.depth = true
        }
      })
    } else {
      for (const key in state.access) {
        state.access[key] = true
      }
    }
  },
  '[pvh] SET_ORDER_UPDATE_STATUS': (state, status) => {
    state.order.status = status
  },
  '[pvh] SET_ORDER_UPDATE_INFORMER_TYPE': (state, type) => {
    state.order.client.informer = type
  },
  '[pvh] SET_ORDER_UPDATE_CLIENT_COMMENT': (state, value) => {
    state.order.client.comment = value
  },
  '[pvh] SET_ORDER_UPDATE_CLIENT_NAME': (state, value) => {
    state.order.client.name = value
  },
  '[pvh] SET_ORDER_UPDATE_CLIENT_SURNAME': (state, value) => {
    state.order.client.surname = value
  },
  '[pvh] SET_ORDER_UPDATE_CLIENT_PATRONYMIC': (state, value) => {
    state.order.client.patronymic = value
  },
  '[pvh] SET_ORDER_UPDATE_CLIENT_ADDRESS': (state, value) => {
    state.order.client.address = value
  },
  '[pvh] SET_ORDER_UPDATE_CLIENT_PHONE': (state, value) => {
    state.order.client.phone = value
  },
  '[pvh] SET_ORDER_UPDATE_CLIENT_EMAIL': (state, value) => {
    state.order.client.email = value
  },
  '[pvh] SET_ORDER_UPDATE_CLIENT_ID': (state, value) => {
    state.order.client.id = value
  },
  '[pvh] SET_ORDER_UPDATE_CONTRACTOR': (state, contractor) => {
    state.order.contractor = contractor
  },
  '[pvh] SET_ORDER_UPDATE_DELIVERY_METHOD': (state, method) => {
    state.order.deliveryMethod = method
  },
  '[pvh] SET_ORDER_UPDATE_GAUGER': (state, gauger) => {
    state.order.gauger = gauger
  },
  '[pvh] SET_ORDER_UPDATE_INSTALLER': (state, installer) => {
    state.order.installer = installer
  },
  '[pvh] SET_ORDER_UPDATE_CODE': (state, value) => {
    state.order.code = value
  },
  '[pvh] SET_ORDER_UPDATE_SQUARE_METERS': (state, value) => {
    state.order.square_meters = value
  },
  '[pvh] SET_ORDER_UPDATE_COUNT': (state, value) => {
    state.order.count = value
  },
  '[pvh] SET_ORDER_UPDATE_CODE_RAL': (state, value) => {
    state.order.code_ral = value
  },
  '[pvh] SET_ORDER_UPDATE_DEPTH': (state, value) => {
    state.order.depth = value
  },
  '[pvh] SET_ORDER_UPDATE_VALUE': (state, value) => {
    state.order.value = value
  },
  '[pvh] SET_ORDER_UPDATE_CHECK': (state) => {
    state.order.is_check = !state.order.is_check
  },
  '[pvh] SET_ORDER_UPDATE_GAUGING_DATE': (state, value) => {
    state.order.gauging_date = value
  },
  '[pvh] SET_ORDER_UPDATE_ADVANCE_DATE': (state, value) => {
    state.order.advance_date = value
  },
  '[pvh] SET_ORDER_UPDATE_AVAILABILITY_DATE': (state, value) => {
    state.order.availability_date = value
  },
  '[pvh] SET_ORDER_UPDATE_INSTALLATION_DATE': (state, value) => {
    state.order.installation_date = value
  },
  '[pvh] SET_ORDER_UPDATE_COST_TYPE': (state, value) => {
    state.order.costTypeModal.select = value
  },
  '[pvh] SET_ORDER_UPDATE_SAMPLES_FILES': (state, value) => {
    state.order.samples = value
  },
  '[pvh] SET_ORDER_UPDATE_TREATIES_FILES': (state, value) => {
    state.order.treaties = value
  },
  '[pvh] SET_ORDER_UPDATE_OTHER_FILES': (state, value) => {
    state.order.other = value
  },
  '[pvh] SET_ORDER_UPDATE_PHOTOGRAPHS_FILES': (state, value) => {
    state.order.photographs = value
  },
  '[pvh] RESET_UPDATED_COMMENTS': (state) => {
    state.order.updatedComments = []
  },
  '[pvh] RESET_DELETED_COMMENTS': (state) => {
    state.order.deletedComments = []
  },

  '[pvh] ADD_ORDER_UPDATE_COST_TYPE': (state) => {
    if (state.order.costTypeModal.value) {
      if (state.order.costTypeModal.updatedId === null) {
        const newId = state.order.costTypes.length ? state.order.costTypes[state.order.costTypes.length - 1].id + 1 : 1

        const item = {
          isActive: false,
          id: newId,
          value: state.order.costTypeModal.value,
          select: {
            name: state.order.costTypeModal?.select?.name,
            id: state.order.costTypeModal?.select?.id
          }
        }
        state.order.costTypes.push(item)
      } else {
        state.order.costTypes.forEach(e => {
          if (e.id === state.order.costTypeModal?.updatedId) {
            e.value = state.order.costTypeModal?.value
            e.select = state.order.costTypeModal?.select
          }
        })
      }

      state.order.costTypeModal.value = ''
      state.order.costTypeModal.select = { name: 'Не выбрано', id: null }
      state.order.costTypeModal.active = false
    } else {
      state.order.costTypeModal.validation.value.type = 'error'
      state.order.costTypeModal.validation.value.message = 'Поле не заполнено'
    }
  },
  '[pvh] SET_ORDER_UPDATE_COST_TYPE_VALUE': (state, value) => {
    state.order.costTypeModal.value = value
  },
  '[pvh] CLOSE_ORDER_UPDATE_COST_TYPE_MODAL': (state) => {
    state.order.costTypeModal = {
      active: false,
      id: null,
      value: '',
      select: {
        id: null,
        name: 'Не выбрано'
      },
      validation: {
        value: {
          type: null,
          message: ''
        }
      }
    }
  },
  '[pvh] SHOW_ORDER_UPDATE_COST_TYPE_MODAL': (state, id) => {
    state.order.costTypeModal.active = true

    if (id !== null) {
      const costType = state.order.costTypes.filter(costType => {
        return costType.id === id
      }).pop()

      state.order.costTypeModal.updatedId = id
      state.order.costTypeModal.value = costType.value
      state.order.costTypeModal.select = costType.select
    }
  },
  '[pvh] SET_ORDER_UPDATE_COST_TYPE_ACTIVE_ALL': (state) => {
    state.order.costTypeTableHeaders.allActive = !state.order.costTypeTableHeaders.allActive
    state.order.costTypes.forEach(e => {
      e.isActive = state.order.costTypeTableHeaders.allActive
    })
    state.order.costTypeIsActiveDelete = state.order.costTypeTableHeaders.allActive
  },
  '[pvh] TOGGLE_ORDER_UPDATE_COST_TYPE_ACTIVE_ITEM': (state, itemId) => {
    const itemsLength = state.order.costTypes.length
    let counter = 0

    state.order.costTypes.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.order.costTypeIsActiveDelete = true : state.order.costTypeIsActiveDelete = false

    state.order.costTypeTableHeaders.allActive = counter === itemsLength
  },
  '[pvh] DELETE_ORDER_UPDATE_COST_TYPE': (state) => {
    state.order.costTypes = state.order.costTypes.filter(e => {
      return !e.isActive
    })
    state.order.costTypeTableHeaders.allActive = false
    state.order.costTypeIsActiveDelete = false
  },
  '[pvh] SET_ORDER_UPDATE_COMING_TYPE': (state, value) => {
    state.order.comingTypeModal.select = value
  },
  '[pvh] ADD_ORDER_UPDATE_COMING_TYPE': (state) => {
    if (state.order.comingTypeModal.value) {
      if (state.order.comingTypeModal.updatedId === null) {
        const newId = state.order.comingTypes.length ? state.order.comingTypes[state.order.comingTypes.length - 1].id + 1 : 1

        const item = {
          isActive: false,
          id: newId,
          value: state.order.comingTypeModal.value,
          select: {
            name: state.order.comingTypeModal.select.name,
            id: state.order.comingTypeModal.select.id
          }
        }
        state.order.comingTypes.push(item)
      } else {
        state.order.comingTypes.forEach(e => {
          if (e.id === state.order.comingTypeModal.updatedId) {
            e.value = state.order.comingTypeModal.value
            e.select = state.order.comingTypeModal.select
          }
        })
      }

      state.order.comingTypeModal.value = ''
      state.order.comingTypeModal.select = { name: 'Не выбрано', id: null }
      state.order.comingTypeModal.active = false
    } else {
      state.order.comingTypeModal.validation.value.type = 'error'
      state.order.comingTypeModal.validation.value.message = 'Поле не заполнено'
    }
  },
  '[pvh] SET_ORDER_UPDATE_COMING_TYPE_VALUE': (state, value) => {
    state.order.comingTypeModal.value = value
  },
  '[pvh] CLOSE_ORDER_UPDATE_COMING_TYPE_MODAL': (state) => {
    state.order.comingTypeModal = {
      active: false,
      id: null,
      value: '',
      select: {
        id: null,
        name: 'Не выбрано'
      },
      validation: {
        value: {
          type: null,
          message: ''
        }
      }
    }
  },
  '[pvh] SHOW_ORDER_UPDATE_COMING_TYPE_MODAL': (state, id) => {
    state.order.comingTypeModal.active = true
    if (id !== null) {
      const comingType = state.order.comingTypes.filter(comingType => {
        return comingType.id === id
      }).pop()

      state.order.comingTypeModal.updatedId = id
      state.order.comingTypeModal.value = comingType.value
      state.order.comingTypeModal.select = comingType.select
    }
  },
  '[pvh] SET_ORDER_UPDATE_COMING_TYPE_ACTIVE_ALL': (state) => {
    state.order.comingTypeTableHeaders.allActive = !state.order.comingTypeTableHeaders.allActive
    state.order.comingTypes.forEach(e => {
      e.isActive = state.order.comingTypeTableHeaders.allActive
    })
    state.order.comingTypeIsActiveDelete = state.order.comingTypeTableHeaders.allActive
  },
  '[pvh] TOGGLE_ORDER_UPDATE_COMING_TYPE_ACTIVE_ITEM': (state, itemId) => {
    const itemsLength = state.order.comingTypes.length
    let counter = 0

    state.order.comingTypes.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.order.comingTypeIsActiveDelete = true : state.order.comingTypeIsActiveDelete = false

    state.order.comingTypeTableHeaders.allActive = counter === itemsLength
  },
  '[pvh] DELETE_ORDER_UPDATE_COMING_TYPE': (state) => {
    state.order.comingTypes = state.order.comingTypes.filter(e => {
      return !e.isActive
    })
    state.order.comingTypeTableHeaders.allActive = false
    state.order.comingTypeIsActiveDelete = false
  },
  '[pvh] SET_ORDER_UPDATE_OBJECT': (state, value) => {
    state.order.objectModal.select = value
  },
  '[pvh] ADD_ORDER_UPDATE_OBJECT': (state) => {
    if (state.order.objectModal.name && state.order.objectModal.code) {
      if (state.order.objectModal.updatedId === null) {
        const newId = state.order.objects.length ? state.order.objects[state.order.objects.length - 1].id + 1 : 1

        const item = {
          isActive: false,
          id: newId,
          name: state.order.objectModal.name,
          code: state.order.objectModal.code
        }
        state.order.objects.push(item)
      } else {
        state.order.objects.forEach(e => {
          if (e.id === state.order.objectModal.updatedId) {
            e.code = state.order.objectModal.code
            e.name = state.order.objectModal.name
          }
        })
      }
      state.order.objectModal.name = ''
      state.order.objectModal.code = ''
      state.order.objectModal.active = false
    } else {
      if (!state.order.objectModal.name) {
        state.order.objectModal.validation.name.type = 'error'
        state.order.objectModal.validation.name.message = 'Поле не заполнено'
      }
      if (!state.order.objectModal.code) {
        state.order.objectModal.validation.code.type = 'error'
        state.order.objectModal.validation.code.message = 'Поле не заполнено'
      }
    }
  },
  '[pvh] SET_ORDER_UPDATE_OBJECT_NAME': (state, value) => {
    state.order.objectModal.name = value
  },
  '[pvh] SET_ORDER_UPDATE_OBJECT_CODE': (state, value) => {
    state.order.objectModal.code = value
  },
  '[pvh] CLOSE_ORDER_UPDATE_OBJECT_MODAL': (state) => {
    state.order.objectModal = {
      active: false,
      id: null,
      value: '',
      validation: {
        value: {
          type: null,
          message: ''
        }
      }
    }
  },
  '[pvh] SHOW_ORDER_UPDATE_OBJECT_MODAL': (state, id) => {
    state.order.objectModal.active = true
    if (id !== null) {
      const object = state.order.objects.filter(object => {
        return object.id === id
      }).pop()

      state.order.objectModal.updatedId = id
      state.order.objectModal.name = object.name
      state.order.objectModal.code = object.code
    }
  },
  '[pvh] SET_ORDER_UPDATE_OBJECT_ACTIVE_ALL': (state) => {
    state.order.objectTableHeaders.allActive = !state.order.objectTableHeaders.allActive
    state.order.objects.forEach(e => {
      e.isActive = state.order.objectTableHeaders.allActive
    })
    state.order.objectIsActiveDelete = state.order.objectTableHeaders.allActive
  },
  '[pvh] TOGGLE_ORDER_UPDATE_OBJECT_ACTIVE_ITEM': (state, itemId) => {
    const itemsLength = state.order.objects.length
    let counter = 0

    state.order.objects.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.order.objectIsActiveDelete = true : state.order.objectIsActiveDelete = false

    state.order.objectTableHeaders.allActive = counter === itemsLength
  },
  '[pvh] DELETE_ORDER_UPDATE_OBJECT': (state) => {
    state.order.objects = state.order.objects.filter(e => {
      return !e.isActive
    })
    state.order.objectTableHeaders.allActive = false
    state.order.objectIsActiveDelete = false
  },

  '[pvh] SET_ORDER_ITEM_VALIDATION': (state, valid) => {
    if (valid?.name) {
      state.validation.clientName.message = valid.name[0]
      state.validation.clientName.type = 'error'
      if (router.history.current.name !== 'PvhOrderUpdate_contact') {
        router.push({ name: 'PvhOrderUpdate_contact' })
      }
    }
    if (valid?.phone) {
      state.validation.clientPhone.message = valid.phone[0]
      state.validation.clientPhone.type = 'error'
      if (router.history.current.name !== 'PvhOrderUpdate_contact') {
        router.push({ name: 'PvhOrderUpdate_contact' })
      }
    }
    if (valid?.email) {
      state.validation.clientEmail.message = valid.email[0]
      state.validation.clientEmail.type = 'error'
      if (router.history.current.name !== 'PvhOrderUpdate_contact') {
        router.push({ name: 'PvhOrderUpdate_contact' })
      }
    }
    if (valid?.order_type_id) {
      state.validation.orderType.message = valid.order_type_id[0]
      state.validation.orderType.type = 'error'
      if (router.history.current.name !== 'PvhOrderUpdate_main') {
        router.push({ name: 'PvhOrderUpdate_main' })
      }
    }
    if (valid?.status_id) {
      state.validation.orderStatus.message = valid.status_id[0]
      state.validation.orderStatus.type = 'error'
      if (router.history.current.name !== 'PvhOrderUpdate_main') {
        router.push({ name: 'PvhOrderUpdate_main' })
      }
    }
  },

  '[pvh] ORDER_UPDATE_CLEAR_VALIDATION': (state, inputName) => {
    // свитч кейсом очищать валидацию в нужном поле по имени инпута
    switch (inputName) {
      case 'name':
        state.validation.name = { type: null, message: '' }
        break
      case 'value':
        state.order.costTypeModal.validation.value = { type: null, message: '' }
        break
      case 'valueComing':
        state.order.comingTypeModal.validation.value = { type: null, message: '' }
        break
      case 'clientName':
        state.validation.clientName = { type: null, message: '' }
        break
      case 'clientPhone':
        state.validation.clientPhone = { type: null, message: '' }
        break
      case 'clientEmail':
        state.validation.clientEmail = { type: null, message: '' }
        break
      case 'objectName':
        state.order.objectModal.validation.name = { type: null, message: '' }
        break
      case 'objectCode':
        state.order.objectModal.validation.code = { type: null, message: '' }
        break
      case 'orderType':
        state.validation.orderType = { type: null, message: '' }
        break
      case 'orderStatus':
        state.validation.orderStatus = { type: null, message: '' }
        break
      default:
        break
    }
  },
  '[pvh] SET_ORDER_UPDATE_CLIENT': (state, value) => {
    state.order.client.select = value
  },
  '[pvh] GET_ORDER_UPDATE_INFORMER_LIST': (state, informer) => {
    state.informerTypes = informer.data.map(informer => {
      return {
        ...informer
      }
    })
  },
  '[pvh] SET_ORDER_UPDATE_CLIENT_INFO': (state, value) => {
    if (value.id) {
      const client = state.clients.filter(client => client.id === value.id)[0]

      state.order.client.name = client.name
      state.order.client.surname = client.surname
      state.order.client.patronymic = client.patronymic
      state.order.client.phone = client.phone
      state.order.client.id = client.id
      state.order.client.address = client.address
      state.order.client.informer = client.informer ? { ...client.informer } : { name: 'Не выбрано', id: null }
      state.order.client.email = client.email
      state.order.client.comment = client.comment
    }
  },
  '[pvh] RESET_ORDER_UPDATE_CLIENT': (state) => {
    state.order.client = {
      id: null,
      name: '',
      surname: '',
      patronymic: '',
      email: '',
      address: '',
      phone: '',
      comment: '',
      informer: {
        name: 'Не выбрано',
        id: null
      },
      select: {
        name: 'Не выбрано',
        id: null
      }
    }
  },
  '[pvh] SET_ORDER_UPDATE_INITIAL_STATE': (state) => {
    state.order = {
      name: '',
      samples: [],
      other: [],
      treaties: [],
      photographs: [],
      comment: '',
      comments: [],
      code: '',
      deleteSamplesFiles: [],
      deleteTreatiesFiles: [],
      deleteOtherFiles: [],
      deletePhotographsFiles: [],
      square_meters: '',
      count: '',
      contractor: { id: null, name: 'Не выбрано' },
      code_ral: '',
      depth: '',
      value: '',
      gauging_date: '',
      advance_date: '',
      availability_date: '',
      installation_date: '',
      is_check: false,
      client: {
        id: null,
        name: '',
        surname: '',
        patronymic: '',
        email: '',
        address: '',
        phone: '',
        comment: '',
        informer: {
          name: 'Не выбрано',
          id: null
        },
        select: {
          name: 'Не выбрано',
          id: null
        }
      },
      costTypeTableHeaders: {
        allActive: false,
        header: [
          {
            title: 'Тип расхода',
            isSortable: false
          },
          {
            title: 'Сумма',
            isSortable: false
          }
        ]
      },
      costTypeModal: {
        active: false,
        updatedId: null,
        value: '',
        select: {
          name: 'Не выбрано',
          id: null
        },
        validation: {
          value: {
            type: null,
            message: ''
          }
        }
      },
      orderType: {
        name: 'Не выбрано',
        id: null,
        statuses: []
      },
      costType: {
        id: null,
        value: '',
        select: {
          name: 'Не выбрано',
          id: null
        }
      },
      costTypes: [],
      costTypeIsActiveDelete: false,
      comingTypeTableHeaders: {
        allActive: false,
        header: [
          {
            title: 'Тип прихода',
            isSortable: false
          },
          {
            title: 'Сумма',
            isSortable: false
          }
        ]
      },
      comingTypeModal: {
        active: false,
        updatedId: null,
        value: '',
        select: {
          name: 'Не выбрано',
          id: null
        },
        validation: {
          value: {
            type: null,
            message: ''
          }
        }
      },
      comingType: {
        id: null,
        value: '',
        select: {
          name: 'Не выбрано',
          id: null
        }
      },
      comingTypes: [],
      comingTypeIsActiveDelete: false,
      objectTableHeaders: {
        allActive: false,
        header: [
          {
            title: 'Наименование',
            isSortable: false
          },
          {
            title: 'Шифр',
            isSortable: false
          }
        ]
      },
      objectModal: {
        active: false,
        updatedId: null,
        name: '',
        code: '',
        validation: {
          name: {
            type: null,
            message: ''
          },
          code: {
            type: null,
            message: ''
          }
        }
      },
      object: {
        id: null,
        name: '',
        code: ''
      },
      objects: [],
      objectIsActiveDelete: false,
      status: {
        name: 'Не выбрано',
        id: null
      },
      deliveryMethod: {
        name: 'Не выбрано',
        id: null
      },
      gauger: {
        name: 'Не выбрано',
        id: null
      },
      installer: {
        name: 'Не выбрано',
        id: null
      },
      updatedComments: [],
      deletedComments: []
    }
    for (const key in state.access) {
      state.access[key] = true
    }

    state.validation = {
      name: { type: null, message: '' },
      clientName: { type: null, message: '' },
      clientPhone: { type: null, message: '' },
      clientEmail: { type: null, message: '' },
      orderType: { type: null, message: '' },
      orderStatus: { type: null, message: '' },
      comment: { type: null, message: '' }
    }
  }
}

const actions = {
  ...vuexFileBase.createActions(),

  async savePVHOrderItem ({ rootState, state, commit, dispatch }, id) {
    const data = {
      order_type_id: state.order.orderType?.id,
      client_id: state.order.client.id,
      agent_id: state.order.contractor?.id,
      gauger_id: state.order.gauger?.id,
      installer_id: state.order.installer?.id,
      delivery_id: state.order.deliveryMethod?.id,
      value: state.order?.value,
      master_id: null,
      availability_date: state.order.availability_date,
      installation_date: state.order.installation_date,
      status_id: state.order.status.id,
      gauging_date: state.order.gauging_date,
      advance_date: state.order.advance_date,
      is_check: state.order.is_check,
      code: state.order.code,
      square_meters: state.order.square_meters,
      count: state.order.count,
      code_ral: state.order.code_ral,
      depth: state.order.depth,
      creator_id: rootState.appData.currentUserData.id,
      facilities: state.order.objects.map(e => {
        return {
          code: e.code,
          name: e.name
        }
      }),
      costs: state.order.costTypes.map(e => {
        return {
          cost_type_id: e.select.id,
          value: e.value
        }
      }),
      incomes: state.order.comingTypes.map(e => {
        return {
          income_type_id: e.select.id,
          value: e.value
        }
      })
    }

    const clientData = {
      ...state.order.client,
      informer_id: state.order.client?.informer?.id
    }

    try {
      if (clientData.id) {
        await PVCClientApi.update(clientData.id, clientData)
      } else {
        const response = await PVCClientApi.create(clientData)
        commit('[pvh] SET_ORDER_UPDATE_CLIENT_ID', response.data.data.id)
      }

      if (id === 'create') {
        await dispatch('createOrder', data)
      } else {
        await dispatch('updateOrder', { id, data })
      }

      await router.push({ name: 'PvhOrderList' })
    } catch (e) {
      console.log(e.response.data)
      showAlertError(e)
      commit('[pvh] SET_ORDER_ITEM_VALIDATION', e.response.data.validation)
    }
  },

  async createOrder ({ dispatch, state }, data) {
    const response = await PVCApi.create(data)
    const id = response.data.data.id

    await dispatch('processComments', id)

    await dispatch('checkAndPostNewFiles', { id, data: state.order, addExpand: false })
  },

  async updateOrder ({ state, dispatch }, { id, data }) {
    await PVCApi.update(id, data)

    await dispatch('processComments', id)
    await dispatch('checkAndDeleteFiles', id)
    await dispatch('processPostAndSortFiles', { data: state.order, id })
  },

  async processComments ({ dispatch }, id) {
    await dispatch('checkAndPostComments', id)
    await dispatch('checkAndPutComments', id)
    await dispatch('checkAndDeleteComments', id)
  },

  async checkAndPostComments ({ rootState, state }, id) {
    const newComments = state.order?.comments?.filter(e => { return e.newComment === true })
    const data = newComments?.length ? newComments.map(comment => ({
      text: comment.value,
      user_id: rootState.appData.currentUserData.id
    })) : null

    if (!data) return

    await Promise.all(data.map(e => pvhApi.postOrderComments(id, e)))
  },

  async checkAndPutComments ({ state, commit }, id) {
    if (!state.order.updatedComments.length) return

    const comments = []

    state.order.updatedComments.forEach(e => {
      state.order.comments.forEach(comment => {
        if (comment.id === e) {
          comments.push(comment)
        }
      })
    })

    if (!comments?.length) return

    await Promise.all(comments.map(e => pvhApi.putOrderComments(id, e, e.id)))
    commit('[pvh] RESET_UPDATED_COMMENTS')
  },

  async checkAndDeleteComments ({ state, commit }, id) {
    if (!state.order.deletedComments?.length) return

    await Promise.all(state.order.deletedComments.map(e => pvhApi.deleteOrderComments(id, e)))
    commit('[pvh] RESET_DELETED_COMMENTS')
  },

  addSamplesFileToDelete ({ commit }, { id }) {
    commit('ADD_FILE_TO_DELETE', { id, key: EOrderFiles.samples })
  },
  addTreatiesFileToDelete ({ commit }, { id }) {
    commit('ADD_FILE_TO_DELETE', { id, key: EOrderFiles.treaties })
  },
  addOtherFileToDelete ({ commit }, { id }) {
    commit('ADD_FILE_TO_DELETE', { id, key: EOrderFiles.other })
  },
  addPhotoFileToDelete ({ commit }, { id }) {
    commit('ADD_FILE_TO_DELETE', { id, key: EOrderFiles.photographs })
  },

  '[pvh] getOrderUpdateInfo' ({ commit, state }, id) {
    const params = {
      expands: 'expand=status,delivery,client,gauger,order_type,installer,creator,facilities,comments,costs,incomes,agent,samples,other,photographs,treaties',
      id
    }

    pvhApi.getOrderUpdateInfo(params).then(response => {
      commit('[pvh] GET_ORDER_FOR_UPDATE', response.data.data)
      commit('[pvh] SET_ORDER_UPDATE_ACCESS')
    }).catch(error => {
      console.log('ошибка получения данных заказа', error)
    })
  },
  '[pvh] createOrderUpdateComment' ({ commit }) {
    usersApi.getCurrentUser().then(response => {
      commit('[pvh] CREATE_ORDER_UPDATE_COMMENT', response.data.data)
    })
  },
  '[pvh] getOrderUpdateOrderTypes' ({ commit }) {
    const params = {
      currentTake: 100,
      currentPage: 1,
      searchFilter: ''
    }

    pvhApi.getOrderTypeList(params).then(response => {
      commit('[pvh] GET_ORDER_UPDATE_ORDER_TYPES', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка типов заказа', error)
    })
  },
  '[pvh] getOrderUpdateContractors' ({ commit }) {
    const params = {
      currentTake: 100,
      currentPage: 1,
      searchFilter: ''
    }

    axios.get(`${url}/partner?${params.searchFilter}&per-page=${params.currentTake}&page=${params.currentPage}`, config).then(response => {
      commit('[pvh] GET_ORDER_UPDATE_CONTRACTORS', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка контрагентов', error)
    })
  },
  '[pvh] getOrderUpdateDeliveryMethods' ({ commit }) {
    const params = {
      currentTake: 100,
      currentPage: 1,
      searchFilter: ''
    }

    pvhApi.getDelivType(params).then(response => {
      commit('[pvh] GET_ORDER_UPDATE_DELIVERY_METHODS', response.data.data)
    }).catch(error => {
      console.log('ошибка получения списка типов доставки', error)
    })
  },
  '[pvh] getOrderUpdateUsers' ({ commit }) {
    const params = {
      searchFilter: state.searchValue ? `search[all]=${state.searchValue}` : '',
      currentTake: 10000,
      currentPage: 1
    }
    usersApi.getAll(params).then(response => {
      commit('[pvh] GET_ORDER_UPDATE_USERS', response.data.data)
    }).catch(error => {
      console.log('ошибка получения юзеров', error)
    })
  },
  '[pvh] getOrderUpdateCostTypes' ({ commit }) {
    const params = {
      searchFilter: state.searchValue ? `search[all]=${state.searchValue}` : '',
      currentTake: 20,
      currentPage: 1
    }
    pvhApi.getCostType(params).then(response => {
      commit('[pvh] GET_ORDER_UPDATE_COST_TYPES', response.data.data)
    }).catch(error => {
      console.log('ошибка получения юзеров', error)
    })
  },
  '[pvh] getOrderUpdateComingTypes' ({ commit }) {
    const params = {
      searchFilter: state.searchValue ? `search[all]=${state.searchValue}` : '',
      currentTake: 20,
      currentPage: 1
    }
    pvhApi.getIncomingType(params).then(response => {
      commit('[pvh] GET_ORDER_UPDATE_COMING_TYPES', response.data.data)
    }).catch(error => {
      console.log('ошибка получения юзеров', error)
    })
  },
  '[pvh] getOrderUpdateClients' ({ commit }) {
    const params = {
      searchFilter: state.searchValue ? `search[all]=${state.searchValue}` : '',
      currentTake: 100,
      currentPage: 1
    }
    pvhApi.getClientList(params).then(response => {
      commit('[pvh] GET_ORDER_UPDATE_CLIENTS', response.data.data)
    }).catch(error => {
      console.log('ошибка получения юзеров', error)
    })
  },
  '[pvh] getOrderUpdateInformerTypes' ({ commit }) {
    const params = {
      searchFilter: '',
      currentTake: 100,
      currentPage: ''
    }
    pvhApi.getInformType(params).then(response => {
      commit('[pvh] GET_ORDER_UPDATE_INFORMER_LIST', response.data)
    })
  },
  '[pvh] orderUpdateSetInformer' ({ commit }, value) {
    commit('[pvh] SET_ORDER_UPDATE_INFORMER', value)
  },
  '[pvh] setOrderUpdateClient' ({ commit }, value) {
    commit('[pvh] SET_ORDER_UPDATE_CLIENT', value)
    commit('[pvh] SET_ORDER_UPDATE_CLIENT_INFO', value)
  },

  '[pvh] orderUpdateClearValidation' ({ commit }, inputName) {
    commit('[pvh] ORDER_UPDATE_CLEAR_VALIDATION', inputName)
  },

  '[pvh] setOrderUpdateInitialState' ({ commit, state }) {
    const params = {
      currentTake: 100,
      currentPage: 1,
      searchFilter: state.searchValue ? `?search[all]=${state.searchValue}` : ''
    }
    pvhApi.getStatusList(params)
      .then(response => {
        commit('[pvh] SET_ORDER_UPDATE_INITIAL_STATE', response.data.data)
        state.isLoading = false
      })
      .catch(error => {
        console.log('Ошибка получения списка клиентов', error)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
